import React from 'react';
import { Box, Button, Card, CardContent, Divider, Stack, Step, StepLabel, Stepper, Typography } from '@mui/material';

const JourneyFormLayout = ({
  title,
  subtitle,
  steps = [],
  activeStep = 0,
  children,
  onBack,
  onNext,
  onSubmit,
  backLabel = 'Back',
  nextLabel = 'Next',
  submitLabel = 'Save',
  disableBack = false,
  disableNext = false,
  disableSubmit = false,
  submitting = false,
  compact = false,
}) => {
  const hasSteps = Array.isArray(steps) && steps.length > 0;
  const isLastStep = !hasSteps || activeStep >= steps.length - 1;

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: compact ? 2 : 3 }}>
        <Stack spacing={2.5}>
          <Stack spacing={0.5}>
            <Typography variant={compact ? 'h6' : 'h5'} fontWeight={800} color="primary.main">
              {title}
            </Typography>
            {subtitle ? (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            ) : null}
          </Stack>

          {hasSteps ? (
            <Stepper activeStep={activeStep} alternativeLabel={!compact}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          ) : null}

          <Box>{children}</Box>
        </Stack>
      </CardContent>

      <Divider />

      <Box sx={{ p: compact ? 1.5 : 2, backgroundColor: 'action.hover' }}>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          {hasSteps && activeStep > 0 ? (
            <Button onClick={onBack} disabled={disableBack || submitting}>
              {backLabel}
            </Button>
          ) : null}

          {hasSteps && !isLastStep ? (
            <Button variant="contained" onClick={onNext} disabled={disableNext || submitting}>
              {nextLabel}
            </Button>
          ) : (
            <Button variant="contained" onClick={onSubmit} disabled={disableSubmit || submitting}>
              {submitting ? 'Saving...' : submitLabel}
            </Button>
          )}
        </Stack>
      </Box>
    </Card>
  );
};

export default JourneyFormLayout;
